export const LanguageCode = {
  English: 'en',
  Mandarin: 'zh',
  Arabic: 'ar',
  Vietnamese: 'vi',
  Cantonese: 'yue',
  Punjabi: 'pa',
  Greek: 'el',
  Italian: 'it',
  Hindi: 'hi',
  Spanish: 'es',
  Yumplatok: 'tcs',
  Kriol: 'rop',
  Djambarrpuyngu: 'djn',
} as const;

export type LanguageCode = (typeof LanguageCode)[keyof typeof LanguageCode];

